export const handleNavigation = (clientName, setNavigationProps, setCreateProjectNavProps, clientDetails) => {
  const {clientId, projectId, currentGroupName} = clientDetails
  setNavigationProps([
    {
      id: clientId,
      key: 'client',
      name: clientName
    },
    {
      id: projectId,
      key: 'project',
      name: currentGroupName
    }
  ])
  setCreateProjectNavProps([
    {
      id: clientId,
      key: 'client',
      name: clientName
    }
  ])
}
